import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "vp-page-meta" }
const _hoisted_2 = {
  key: 0,
  class: "vp-meta-item edit-link"
}
const _hoisted_3 = { class: "vp-meta-item git-info" }
const _hoisted_4 = {
  key: 0,
  class: "vp-meta-item last-updated"
}
const _hoisted_5 = { class: "meta-item-label" }
const _hoisted_6 = { class: "meta-item-info" }
const _hoisted_7 = {
  key: 1,
  class: "vp-meta-item contributors"
}
const _hoisted_8 = { class: "meta-item-label" }
const _hoisted_9 = { class: "meta-item-info" }
const _hoisted_10 = ["title"]

import VPAutoLink from '@theme/VPAutoLink.vue'
import VPEditIcon from '@theme/VPEditIcon.vue'
import { useContributors } from '@theme/useContributors'
import { useEditLink } from '@theme/useEditLink'
import { useLastUpdated } from '@theme/useLastUpdated'
import { useThemeLocaleData } from '@theme/useThemeData'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPPageMeta',
  setup(__props) {

const themeLocale = useThemeLocaleData()
const editLink = useEditLink()
const lastUpdated = useLastUpdated()
const contributors = useContributors()

return (_ctx: any,_cache: any) => {
  const _component_ClientOnly = _resolveComponent("ClientOnly")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    (_unref(editLink))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(VPAutoLink, {
            class: "label",
            config: _unref(editLink)
          }, {
            before: _withCtx(() => [
              _createVNode(VPEditIcon)
            ]),
            _: 1
          }, 8, ["config"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_unref(lastUpdated))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(themeLocale).lastUpdatedText) + ": ", 1),
            _createVNode(_component_ClientOnly, null, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(lastUpdated)), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(contributors) && _unref(contributors).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(themeLocale).contributorsText) + ": ", 1),
            _createElementVNode("span", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contributors), (contributor, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("span", {
                    class: "contributor",
                    title: `email: ${contributor.email}`
                  }, _toDisplayString(contributor.name), 9, _hoisted_10),
                  (index !== _unref(contributors).length - 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(", ")
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})